import { useEffect } from 'react';

const useOverflowMenu = (
  menuRef: React.RefObject<HTMLDivElement>,
  onClick: () => void,
  open: boolean
) => {
  useEffect(() => {
    const closeKeyHandler = ({ key }: KeyboardEvent) => {
      if (key === 'Escape' && open) {
        onClick?.();
      }
    };

    const onMouseDown = (event: MouseEvent) => {
      const clickedInsideContainer = menuRef.current?.contains(
        event.target as Node
      );

      if (clickedInsideContainer || !open) {
        return;
      }

      onClick?.();
    };

    document.addEventListener('keydown', closeKeyHandler);
    document.addEventListener('mousedown', onMouseDown);

    return () => {
      document.removeEventListener('keydown', closeKeyHandler);
      document.removeEventListener('mousedown', onMouseDown);
    };
  });
};

export default useOverflowMenu;
